import api from '@/lib/axios';

export type WalkthroughStatus = 'pending' | 'in_progress' | 'completed' | 'dismissed';
export interface WalkthroughState { journey?: 'team_member' | 'trainer' | 'leader' | 'director' | 'admin'; status?: WalkthroughStatus; }

export const walkthroughService = {
  get: async (): Promise<WalkthroughState> => {
    const res = await api.get('/api/walkthrough');
    return res.data;
  },
  update: async (status: WalkthroughStatus): Promise<WalkthroughState> => {
    const res = await api.patch('/api/walkthrough', { status });
    return res.data;
  }
};
